"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostalAddress = void 0;
const models_1 = require("lincd/lib/models");
const package_1 = require("../package");
const Thing_1 = require("./Thing");
const schema_1 = require("../ontologies/schema");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const AdministrativeArea_1 = require("./AdministrativeArea");
let PostalAddress = class PostalAddress extends Thing_1.Thing {
    get postalCode() {
        return this.getValue(schema_1.schema.postalCode);
    }
    set postalCode(val) {
        this.overwrite(schema_1.schema.postalCode, new models_1.Literal(val));
    }
    get areaServed() {
        return this.getOneAs(schema_1.schema.areaServed, AdministrativeArea_1.AdministrativeArea);
    }
    set areaServed(val) {
        this.overwrite(schema_1.schema.areaServed, val ? val.node : null);
    }
};
exports.PostalAddress = PostalAddress;
PostalAddress.targetClass = schema_1.schema.Thing;
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: schema_1.schema.postalCode,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], PostalAddress.prototype, "postalCode", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: schema_1.schema.areaServed,
    }),
    __metadata("design:type", AdministrativeArea_1.AdministrativeArea),
    __metadata("design:paramtypes", [AdministrativeArea_1.AdministrativeArea])
], PostalAddress.prototype, "areaServed", null);
exports.PostalAddress = PostalAddress = __decorate([
    package_1.linkedShape
], PostalAddress);
//# sourceMappingURL=PostalAddress.js.map